import { CommonModule } from '@angular/common'
import { AfterViewInit, Component, OnDestroy } from '@angular/core'
import { animationFadeInOut } from '@engineering11/ui-lib/e11-animations'
import { E11LoaderGlobalService } from '@engineering11/ui-lib/e11-loader-dots'
import { Subject, takeUntil } from 'rxjs'
import { LoaderLinkComponent } from './loader-link.component'

/**
 * Full screen Link Loop, driven by the shared `E11LoaderGlobalService`.
 *
 * Replaces `e11-loader-global`, which renders the library's dots. The service is unchanged, so
 * everything that already calls `loaderService.open()` / `.close()` keeps working.
 */
@Component({
  selector: 'cnect-loader-link-global',
  standalone: true,
  imports: [CommonModule, LoaderLinkComponent],
  animations: [animationFadeInOut()],
  template: `
    <ng-container *ngIf="config">
      <cnect-loader-link
        [fullScreen]="true"
        [color]="config.color"
        [size]="config.size"
        [fontSize]="config.fontSize"
        [fontColor]="config.fontColor"
        [label]="config.label"
        [buttonLoader]="config.buttonLoader"
        [fade]="config.fade"
        [hasBackdrop]="config.hasBackdrop"
        [backdropStyle]="config.backdropStyle"
        [@animationFadeInOut]
      ></cnect-loader-link>
    </ng-container>
  `,
})
export class LoaderLinkGlobalComponent implements AfterViewInit, OnDestroy {
  config: any = null
  private destroy$ = new Subject<void>()

  constructor(private loaderService: E11LoaderGlobalService) {}

  ngAfterViewInit(): void {
    this.loaderService.config$.pipe(takeUntil(this.destroy$)).subscribe(config => (this.config = config))
  }

  ngOnDestroy(): void {
    this.destroy$.next()
    this.destroy$.complete()
  }
}
